export const batchStatusOptions = [
  { label: 'Success', value: 'success' },
  { label: 'Validation', value: 'validation' },
  { label: 'System', value: 'system' },
  { label: 'Decompression', value: 'decompress' },
  { label: 'Duplicates', value: 'duplicate_batch' },
  { label: 'Empty batches', value: 'empty_batch' }
];

export const columns = ['Time', 'Status', 'Events', 'Batch ID'];
